import { render } from "./InvoiceOffers.vue?vue&type=template&id=23791da8&ts=true"
import script from "./InvoiceOffers.vue?vue&type=script&lang=ts"
export * from "./InvoiceOffers.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__